import type InfoCard from "@/features/cards/deprecated/info-cards/info-card";

export interface AddDeviceGlobalStateType {
    loaded: boolean;
    AddDeviceCardInstance: InfoCard | undefined;
    // FocusContext instance; kept untyped to avoid importing focus-context here.
    AddDeviceContext: { ghost?: boolean } | undefined;
    /** True when the add-device flow is on its terminal step (success or failure). */
    isOnFinalStep: boolean;
}

export const AddDeviceGlobalState: AddDeviceGlobalStateType = {
    loaded: false,
    AddDeviceCardInstance: undefined,
    AddDeviceContext: undefined,
    isOnFinalStep: false,
};
